import { StyledModal } from "../../../components/UI/StyledModal";
import { StyledBackdrop } from "../../../components/UI/StyledBackdrop";
import styled from "styled-components";
import { IoMdSync } from "react-icons/io";

type Props = {
  showModal: boolean;
};

export const SyncProductsStatusModal = ({ showModal = true }: Props) => {
  return (
    <>
      <StyledBackdrop showModal={showModal} />
      <StyledModal
        showModal={showModal}
        style={{
          minWidth: "400px",
          width: "auto",
          height: "auto",
        }}
      >
        <StyledSyncProductsStatusContainer>
          <IoMdSync size={100} className="sync-icon" />
          <div className="sync-message">
            <p>Ο συγχρονισμός των προϊόντων βρίσκεται σε εξέλιξη.</p>
            <p>Παρακαλώ περιμένετε...</p>
          </div>
        </StyledSyncProductsStatusContainer>
      </StyledModal>
    </>
  );
};

const StyledSyncProductsStatusContainer = styled.div`
  text-align: center;

  .sync-message {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .sync-icon {
    color: var(--primary-color);
    animation: spin 1s linear infinite;
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;
